var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyProjectListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 151,
    viewBox: "0 0 150 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 75.3633,
    r: 75,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.3337 92.0301H91.667V100.363H58.3337V92.0301ZM58.3337 75.3634H91.667V83.6968H58.3337V75.3634ZM83.3337 33.6968H50.0003C45.417 33.6968 41.667 37.4468 41.667 42.0301V108.697C41.667 113.28 45.3753 117.03 49.9587 117.03H100C104.584 117.03 108.334 113.28 108.334 108.697V58.6968L83.3337 33.6968ZM100 108.697H50.0003V42.0301H79.167V62.8634H100V108.697Z",
    fill: "#498E2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProjectListIcon);
export default __webpack_public_path__ + "static/media/empty-project-list-icon.769c86675e6de64512a1ccf1bfcd7dc8.svg";
export { ForwardRef as ReactComponent };